import { VEHICLE_FETCHED } from '../actions/vehicles';
import { find } from 'lodash';

const initialState = { list: [] };

export default function vehicles(state = initialState, action) {
  switch (action.type) {
    case VEHICLE_FETCHED: {
      const exists = find(state.list, { id: action.vehicle.id });
      if (exists) return state;
      return {
        ...state,
        list: [...state.list, action.vehicle]
      };
    }

    default:
      return state;
  }
}
